import React, { useEffect, useState } from 'react'
import AddLocationTools from './AddLocationTools'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DataGrid } from '@mui/x-data-grid';
import AddLocationModal from './AddLocationModal';
import { LocationDelete, LocationShowdata } from '../../../services/LoginPageService';
import { Tooltip } from '@mui/material';
import DeleteConfirmationDailog from '../../../utils/confirmDeletion';
import NotificationBar from '../../notification/ServiceNotificationBar';

const AddLocationList = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editLocation, setEditLocation] = useState('');
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    // {
    //   field: 'time',
    //   headerClassName: 'super-app-theme--header',
    //   headerName: 'Time',
    //   minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    // },
    {
      field: 'description',
      headerName: 'Description',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 250,
      cellClassName: 'actions',
      disableClickEventBubbling: true,
      getActions: (params) => [
        <EditData selectedRow={params.row} />, 
        <DeleteData selectedRow={params.row} />,
        
      ],
    },
  ];

  useEffect(()=>{
    LocationShowdata(handleLocationShow,handeLocationException);
  },[refreshData]);
  
  const handleLocationShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }

  const handeLocationException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  function EditData(props) {
    return (
      <Tooltip title="Edit">
        <EditIcon style={{cursor: 'pointer'}}
          onClick={(event) => {
            event.stopPropagation();
            setIsAddButton(false);
            setEditLocation(props.selectedRow);
            setOpen(true);
          }}
        />
      </Tooltip>
    );
  }

  function DeleteData(props) {
    return (
      <Tooltip title="Delete">
        <DeleteIcon style={{color:'#012738',cursor: 'pointer'}}
        onClick={() => {
          setDeleteId(props.selectedRow.id);
          console.log(props.selectedRow.id);
          setDeleteDailogOpen(true); 
        }}/>
      </Tooltip>
    );
  }

  const DeleteFunction =()=>{
    LocationDelete(handleDeleteSuccess,handleDeleteException);
  }

  const handleDeleteSuccess = (dataObject) =>{
    console.log(dataObject);
    setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    }); 
    setTimeout(()=>{
      setDeleteDailogOpen(false);
    }, 2000);
    setRefreshData(oldValue => !oldValue);
  }
  
  const handleDeleteException = (errorObject, message) =>{
    console.log(message);
    setNotification({
      status: true,
      type: 'error',
      message:message,
    });
  }

  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };
    
  return (
    <div style={{marginLeft:'10px',overflow: "scroll",marginRight:'5px'}}>
      <AddLocationTools 
        setIsAddButton={setIsAddButton}
        editlocation={editLocation}
        setOpen={setOpen}
        setEditLocation={setEditLocation}
      />
      <AddLocationModal
        isAddButton={isAddButton}
        editLocation={editLocation}
        setEditLocation={setEditLocation}
        open={open}
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        handleClose={handleClose}
        openNotification={openNotification}
        setNotification={setNotification}
      />

      <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />
      
      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
        deleteService={LocationDelete}
        handleSuccess={handleDeleteSuccess}
        handleException={handleDeleteException}
      />
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
          height: '480px',
          width: '100%',
          '& .super-app-theme--header': {
            WebkitTextStrokeWidth:'0.6px',
          },
        }}
      />
    </div>
  )
}

export default AddLocationList